import {
  concretiseParams,
  updateSearchParamsWithFilters,
} from "../filters/filters"
import { updateSearchParamsWithPagination } from "../../page"
import { API_BASE_URL } from "../../app/config"
import spaceOrgs from "./space-orgs.json"
import { getToken, handleSignIn } from "../iam/middleware"

/**
 * Get Resident space objects (RSOs)
 * @param filers  // filters to apply
 * @param page  // pagination settings
 * @returns {Promise<any>}
 */
export const getRSOs = async ({ filter = {}, page = {} }) => {
  // Build parameter set
  const params = new URLSearchParams()
  updateSearchParamsWithFilters(params, filter)
  // Replace any relative ones with absolute ones
  concretiseParams(params)
  // Pagination control
  updateSearchParamsWithPagination(params, page)

  let resp = await fetch(
    `${API_BASE_URL}/api/satellites?${params.toString()}`,
    {
      method: "GET",
      mode: "cors",
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${getToken()}`,
      },
      redirect: "error",
    }
  )

  resp = handleSignIn(resp)
  return resp.json()
}

/**
 * Get an RSO by its ID
 * @param norad_id
 * @returns {Promise<any>}
 */
export const getRSOById = async (noradId) => {
  let resp = await fetch(`${API_BASE_URL}/api/satellites/${noradId}`, {
    method: "GET",
    mode: "cors",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${getToken()}`,
    },
    redirect: "error",
  })

  resp = handleSignIn(resp)
  return resp.json()
}

/**
 * Returns a list of all space organisations (reference data).
 * @returns {Promise<any>}
 */
export const getSpaceOrganisation = async () => {
  return Promise.resolve(spaceOrgs)
}

/**
 * Create a new user RSO
 *
 * @param request  // the details of the RSO
 * @returns {Promise<any>}
 */
export const createUserRSO = async (req) => {
  let resp = await fetch(`${API_BASE_URL}/api/satellites`, {
    method: "POST",
    mode: "cors",
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(req),
    redirect: "error",
  })

  resp = handleSignIn(resp)
  return resp.json()
}

/**
 * Mark a User created RSO  as deleted
 *
 * @param id  // id of the RSO we want to delete
 * @returns {Promise<any>}
 */
export const markRSOAsDeleted = async (id) => {
  let resp = await fetch(`${API_BASE_URL}/api/satellites/${id}`, {
    method: "DELETE",
    mode: "cors",
    headers: {
      Authorization: `Bearer ${getToken()}`,
    },
    cache: "no-cache",
    redirect: "error",
  })
  resp = handleSignIn(resp)
  return resp.json()
}

/**
 * Update the TLE of user RSO
 *
 * @param req the details of the new TLE
 * @returns {Promise<any>}
 */
export const updateTLE = async (req = {}) => {
  let resp = await fetch(`${API_BASE_URL}/api/satellites/${req.id}/tle`, {
    method: "PUT",
    mode: "cors",
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(req),
    redirect: "error",
  })

  resp = handleSignIn(resp)
  return resp.json()
}

/**
 * Update the name of user RSO
 *
 * @param req the details of the new name
 * @returns {Promise<any>}
 */
export const updateObjectName = async (req = {}) => {
  let resp = await fetch(`${API_BASE_URL}/api/satellites/${req.id}/name`, {
    method: "PUT",
    mode: "cors",
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(req),
    redirect: "error",
  })

  resp = handleSignIn(resp)
  return resp.json()
}

/**
 * Update the COSPAR ID of user RSO
 *
 * @param req the details of the new name
 * @returns {Promise<any>}
 */
export const updateObjectCospar = async (req = {}) => {
  let resp = await fetch(`${API_BASE_URL}/api/satellites/${req.id}/cospar`, {
    method: "PUT",
    mode: "cors",
    headers: {
      Authorization: `Bearer ${getToken()}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify(req),
    redirect: "error",
  })

  resp = handleSignIn(resp)
  return resp.json()
}
